import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxChip',
  props: {
  manager: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

//region Props and Emits

const props = __props

//endregion

//region Variables

const extraClasses = computed(() =>
  props.manager ? ["text-h4", "sfx-chip-manager"] : ["text-h6", "sfx-chip-technician"]
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createBlock(_component_q_chip, _mergeProps({
    class: ["sfx-chip", extraClasses.value],
    ripple: false,
    square: ""
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})